import { Link, Typography } from "@mui/material";

interface linkeTileProps { linkTo: string; imgSrc: string; footer: string; }


const TileLink = (props: linkeTileProps) => {
    const goToURL = () => {
        window.location.href = props.linkTo;
    }
    return <>
        <Link onClick={goToURL} style={{ width: '95%', textAlign: 'center' }}>
            <img src={props.imgSrc} style={{ width: '100%' }} />
            <Typography style={{ textAlign: 'center' }}>{props.footer}</Typography>
        </Link></>
}

export default TileLink;